import {
  IS_LOADING,
  IS_NOT_LOADING,
  FULLY_AUTHENTICATED,
  NOT_AUTHENTICATED,
} from '../actions/authActions';

const initialState = {
  isLoading: true,
  isFullyAuthenticated: false
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false
      };
    case FULLY_AUTHENTICATED:
      return {
        isLoading: false,
        isFullyAuthenticated: true
      };
    case NOT_AUTHENTICATED:
      return {
        isLoading: false,
        isFullyAuthenticated: false
      };
    default:
      return state;
  }
};

export default auth;
